import Vue from 'vue'
import VueRouter from 'vue-router'
import Blocks from '../views/Blocks.vue'
import About from '../views/About.vue'
import DataUnits from '../views/DataUnits.vue'
import SingleBlock from '../views/SingleBlock.vue'


import AddDataUnit from '../views/admin/AddDataUnit.vue'
import AddPeer from '../views/admin/AddPeer.vue'
import PreAddNode from '../views/admin/PreAddNode.vue'
import PreRemoveNode from '../views/admin/PreRemoveNode.vue'
import Locate from '../views/Locate.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Blocks',
    component: Blocks
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/dataunits',
    name: 'Data Units',
    component: DataUnits
  },
  {
    path: '/locate',
    name: 'Locate',
    component: Locate
  },
  {
    path: '/blocks/:id',
    name: 'Single Block',
    component: SingleBlock
  },
  {
    path: '/admin/addDataUnit',
    name: 'Add Data Unit',
    component: AddDataUnit
  },
  {
    path: '/admin/addPeer',
    name: 'Add Peer',
    component: AddPeer
  },
  {
    path: '/admin/preAddNode',
    name: 'PreAddNode',
    component: PreAddNode
  },
  {
    path: '/admin/preRemoveNode',
    name: 'PreRemoveNode',
    component: PreRemoveNode
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

document.body.style.backgroundColor = "#f1f1f1";
document.body.style.fontFamily = "Sarabun"

export default router
